import { Injectable } from '@angular/core';

import { Placement } from '@shure/shared/angular/data-access/system-api/models';

import { Mxa7xxBaseLookupTableLoaderService } from '../mxa7xx-base-lookup-table-loader.service';
import { CoveragePerspectives } from '../mxa7xx-lookup-table-loader.api';
import { Mxa7xxModel } from '../mxa7xx-model';

/**
 * Loads look up data tables from files.
 *
 * Application must copy global asset files to local assets folder
 * by adding bellow to 'apps/../app/project.json' targets.build.options.assets array
 *
 * 	{
					"glob": "(Medium|Narrow|Wide)-(angle|cx|cy|rx|ry)-table.csv",
					"input": "./assets/mxa710-lookup-data",
					"output": "./assets/mxa710-lookup-data"
 * 	}
 */

@Injectable({ providedIn: 'root' })
export class Mxa710LookupTableLoaderService extends Mxa7xxBaseLookupTableLoaderService {
	protected readonly lookupDataPath = './assets/mxa710-lookup-data';

	protected readonly supportedTables: Map<CoveragePerspectives, Placement[]> = new Map([
		[CoveragePerspectives.TopDown, [Placement.Ceiling]]
	]);
	public readonly mxa7xxModel: Mxa7xxModel = Mxa7xxModel.MXA710;
}
